// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"e0b28c78","244":"89590a5f","246":"85214121","532":"6211e455"}[chunkId] + ".chunk.js";
};